/**
 * Presenter ↔ speaker-notes window, same browser. Absolute state from the presenter on every change;
 * commands back from the notes window. BroadcastChannel: no server round trip, works offline.
 */
export type NotesState = {
  type: "state";
  slideIndex: number;
  stop: number;
  slides: number;
  nowTitle: string;
  notes: string | null;
  nextTitle: string | null;
  section: { number: number; title: string; budgetMs: number } | null;
  sectionMs: number;
  totalMs: number;
  totalBudgetMs: number;
  running: boolean;
  started: boolean;
  live: boolean;
  code: string | null;
};
export type NotesCommand = { type: "command"; action: "next" | "prev" | "toggle-timer" | "blank" | "reset-timer" };
export type NotesHello = { type: "hello" };
export type NotesMessage = NotesState | NotesCommand | NotesHello;

export function channelName(deckId: string): string {
  return `hali-shares-notes-${deckId}`;
}

export function openChannel(deckId: string): BroadcastChannel | null {
  return typeof BroadcastChannel === "undefined" ? null : new BroadcastChannel(channelName(deckId));
}
